"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const qs = require("query-string");
exports.allNumberRegExp = /^\d+$/;
function convertQueryToString(obj) {
    const queryArray = Object.keys(obj).reduce((pValue, cValue) => {
        if (typeof obj[cValue] !== "undefined") {
            pValue.push(`${cValue}=${typeof obj[cValue] === "string" ? encodeURIComponent(obj[cValue]) : obj[cValue]}`);
        }
        return pValue;
    }, []);
    return queryArray.length > 0 ? `?${queryArray.join("&")}` : "";
}
exports.convertQueryToString = convertQueryToString;
function decode(str) {
    let r = str;
    try {
        r = decodeURIComponent(str);
    }
    catch (e) {
        console.error(`'${str}' decodeURIComponent failed.`);
    }
    return r;
}
function parse(reg, link) {
    let ret = null;
    const res = reg.exec(link);
    if (res !== null) {
        ret = { hostname: res[1], query: {} };
        if (typeof res[2] !== "undefined") {
            ret.query = res[2].split("&").reduce((pValue, cValue) => {
                const [key, value] = cValue.split("=");
                if (typeof key !== "undefined" && typeof value !== "undefined") {
                    pValue[key] = decode(value);
                    if (key !== key.toLowerCase()) {
                        pValue[key.toLowerCase()] = decode(value);
                    }
                }
                return pValue;
            }, {});
        }
    }
    return ret;
}
exports.parse = parse;
function doAppRedirect(href, open) {
    if (open) {
        window.open(href);
    }
    else {
        window.location.href = href;
    }
}
exports.doAppRedirect = doAppRedirect;
function generateAddress(hostname, params) {
    let paramStr = "";
    let paramStrArray = [];
    if (typeof params !== "undefined" && params instanceof Object) {
        for (let key in params) {
            let value = params[key];
            if (Array.isArray(value)) {
                value = JSON.stringify(value);
            }
            if (typeof value !== "undefined") {
                paramStrArray.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
            }
        }
    }
    if (paramStrArray.length > 0) {
        paramStr = "?" + paramStrArray.join("&");
    }
    return `${hostname}${paramStr}`;
}
exports.generateAddress = generateAddress;
function fixHttpLink(url) {
    if (!/^(https?:)?\/\//.test(url)) {
        const prefix = `${location.protocol}//${window.location.host}${url.startsWith("/") ? "" : "/"}`;
        url = `${prefix}${url}`;
    }
    return url;
}
exports.fixHttpLink = fixHttpLink;
function getUrlQuery(link) {
    let query = {};
    try {
        const url = new URL(link);
        query = qs.parse(url.search);
    }
    catch (e) {
        /* istanbul ignore next */
        console.error(e);
    }
    return query;
}
exports.getUrlQuery = getUrlQuery;
